import React from 'react';
import { Link } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import hourglass from '../assets/images/hourglass.png';
import EDSFooter from '../components/EDSFooter';
import Header from '../components/Elements/header/header';
import { useState } from 'react';
import CustomButtons from '../components/Elements/Buttons/customButton';
import { useHistory } from 'react-router-dom';

const Error_token_wygasl = () => {
    const [header, setHeader] = useState('/  TOKEN WYGASŁ');
    const history = useHistory();
    return (
        <>
            <Header>{header}</Header>
            <div className="content responsive-padding margin-top-32">
                <div className="half-half half-half--text-to-left">
                    <main className="">
                        <div style={{ display: 'none' }}>
                            <a href="">
                                <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                            </a>
                        </div>
                        <section className="margin-top-64 margin-bottom-32 statueContentSection">
                            <h2 className="forAllTittle">Token wygasł.</h2>
                            <p className="margin-top-16">
                                Pamiętaj, masz <span className="fw-700">24 godziny</span> by kliknąć
                                na podany w mailu link aktywacyjny.
                            </p>
                            <p className="margin-top-8">
                                Jeżeli nie widzisz maila, sprawdź foldery{' '}
                                <span className="fw-700">spamu i poczty masowej</span>.
                            </p>
                            <p className="margin-top-32 ">Spróbuj odzyskać hasło jeszcze raz.</p>
                            <CustomButtons
                            clickFunction={(e) => {
                                history.push("/LoginBuy/key=")
                            }}
                            classButton="solid"
                            size="big"
                        >
                            Odzyskaj hasło
                        </CustomButtons>
                           
                            <h2 className="forAllTittle margin-top-32">INFOLINIA</h2>
                            <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                            <p>w godzinach 9:00 - 17:00</p>
                            <p className="margin-top-16">tel.: 601 20 20 20</p>
                            <p>e-mail: studio@egurrola.pl</p>
                           
                        </section>
                    </main>
                    
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Error_token_wygasl;
